export interface ProjectFile {
  extension: string;
  id: string;
  name: string;
  notes: string;
  path: string;
  type: string;
  uploadedAt: string;
  uploadedBy: string;
  utilityRequest?: string;
}

export const fileTypes = [
  '.xls',
  '.xlsx',
  '.pdf',
  '.csv',
  '.doc',
  '.docx',
  '.docm',
  '.ppt',
  '.pptx',
  '.pptm',
  '.zip',
  '.kmz',
  '.kml',
];

export const mediaTypes = [
  '.jpg',
  '.jpeg',
  '.png',
  '.svg',
  '.gif',
  '.tif',
  '.tiff',
  '.eps',
  '.raw',
  '.cr2',
  '.nef',
  '.orf',
  '.sr2',
  '.webm',
  '.mkv',
  '.flv',
  '.vob',
  '.ogv',
  '.ogg',
  '.rrc',
  '.gifv',
  '.mng',
  '.mov',
  '.avi',
  '.qt',
  '.wmv',
  'yuv',
  '.rm',
  '.asf',
  '.amv',
  '.mp4',
  '.m4p',
  '.m4v',
  '.mpg',
  '.mp2',
  '.mpeg',
  '.mpe',
  '.mpv',
  '.m4v',
  '.svi',
  '.3gp',
  '.3g2',
  '.mxf',
  '.roq',
  '.nsv',
  '.flv',
  '.f4v',
  '.f4p',
  '.f4a',
  '.f4b',
];

export const fileTypesNoDots = fileTypes.map((type) => type.split('.')[1]);
export const mediaTypesNoDots = mediaTypes.map((type) => type.split('.')[1]);
